import { action } from 'satcheljs';
import { ComposeViewState } from 'owa-mail-compose-store';

/**
 * Action triggered when Accessibility checker button is clicked from mail tip
 */
export default action('onAccessibilityCheckerClickFromMailTip', (viewState: ComposeViewState) => ({
    viewState,
}));
